import React from "react"
import ServiceProvidersList from "../components/ServiceProvidersList/ServiceProvidersList"
import {ServiceProvidersContextProvider} from "../components/ServiceProvidersList/ServiceProvidersContext";

const UserListContainer = () => {
  return (
    <div>
      <ServiceProvidersContextProvider>
        <ServiceProvidersList />
      </ServiceProvidersContextProvider>
    </div>
  )
}

export default UserListContainer
